import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Switch,
  IconButton,
} from "@mui/material";
import FileUploadIcon from "@mui/icons-material/UploadFile";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const InviteModal = ({ open, onClose }) => {
  const [emailRequired, setEmailRequired] = useState(true);
  const [shareLink, setShareLink] = useState(false);
  const [inviteLink, setInviteLink] = useState("");
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleFileChange = (e) => setFile(e.target.files[0]);

  const handleCreateLink = () => {
    const link = "https://example.com/invite-link";
    setInviteLink(link);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(inviteLink);
    alert("Link copied!");
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "white",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
        }}
      >
        <IconButton
          sx={{ position: "absolute", top: 8, right: 8 }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h4" sx={{ mb: 2 }}>
          Invite People
        </Typography>

        <TextField
          fullWidth
          variant="outlined"
          placeholder="Add names or emails separated by commas"
          sx={{ mb: 2 }}
        />

        <Typography variant="body2" sx={{ mb: 1 }}>
          Or upload a CSV file
        </Typography>

        <Button
          component="label"
          variant="contained"
          startIcon={<FileUploadIcon />}
          sx={{ mb: 2 }}
        >
          Choose File
          <input type="file" hidden onChange={handleFileChange} />
        </Button>
        {file && <Typography variant="body2">{file.name}</Typography>}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
            mb: 1,
          }}
        >
          <Typography>Share Link</Typography>
          <Switch checked={shareLink} onChange={() => setShareLink(!shareLink)} />
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography>Email Required</Typography>
          <Switch
            checked={emailRequired}
            onChange={() => setEmailRequired(!emailRequired)}
          />
        </Box>

        {shareLink && (
          <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
            <Button variant="contained" onClick={handleCreateLink}>
              Create Link
            </Button>
            {inviteLink && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <TextField size="small" value={inviteLink} disabled />
                <IconButton onClick={handleCopy}>
                  <ContentCopyIcon />
                </IconButton>
              </Box>
            )}
          </Box>
        )}

        <TextField
          fullWidth
          label="Message"
          variant="outlined"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          sx={{ mb: 2 }}
        />

        <Button fullWidth variant="contained">
          Send
        </Button>
      </Box>
    </Modal>
  );
};

export default InviteModal;
